import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface SelectDiscountProps {
  isDiscountable: boolean;
}

const SelectDiscount: React.FC<SelectDiscountProps> = ({ isDiscountable }) => {
  const { t } = useTranslation('common');

  return (
    <Form.Item noStyle name="discountType" rules={[{ required: isDiscountable }]}>
      <Select
        className="custom-select"
        style={{
          width: 100,
          background: isDiscountable ? 'white' : 'transparent',
          border: '1px solid #d9d9d9',
          borderRadius: '6px',
          height: '100%',
        }}
        placeholder={t('enter-text')}
        options={[
          {
            value: '#',
            label: '#',
          },
          {
            value: '%',
            label: '%',
          },
        ]}
        disabled={!isDiscountable}
      />
    </Form.Item>
  );
};

export default SelectDiscount;
